import * as type from './constant';

export const getWBS = (params = undefined, selfRole = undefined) => ({
  type: type.GET,
  params,
  selfRole,
});

export const getWBSSuccess = (payload) => ({
  type: type.GET_SUCCESS,
  payload,
});

export const getWBSError = (error) => ({
  type: type.GET_ERROR,
  error,
});

export const addWBS = (payload, selfRole = undefined) => ({
  type: type.ADD,
  payload,
  selfRole
});

export const addWBSSuccess = (payload) => ({
  type: type.ADD_SUCCESS,
  payload,
});

export const updateWBS = (id, payload, selfRole = undefined) => ({
  type: type.UPDATE,
  id,
  payload,
  selfRole,
});

export const updateWBSSuccess = (payload) => ({
  type: type.UPDATE_SUCCESS,
  payload,
});

export const deleteWBS = (ids, selfRole = undefined) => ({
  type: type.DELETE,
  ids,
  selfRole,
});

export const deleteWBSSuccess = (payload) => ({
  type: type.DELETE_SUCCESS,
  payload,
});

export const manipulationWBSError = (error) => ({
  type: type.MANIPULATION_ERROR,
  error,
});
